import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "@emotion/styled"
import CommonTemplate from "templates/common-template"
import SingleColumn from "components/pages/singleColumn"
import TeamList from "components/lists/teams-list"

const HighlightText = styled.span`
    color: ${(props) => props.theme.colors.primary};
    font-weight: bold;
`

const BlueBox = styled.div`
    padding: 2rem;
    background-color: ${(props) => props.theme.colors.light_blue_2};
    bottom: 3rem;
    height: auto;
    border-radius: 1rem;
    margin-bottom: 1rem;

    & p {
        padding: 0 1rem;
        color: ${(props) => props.theme.colors.primary};
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        & div {
            flex-direction: column;
        }
    }
`

// markup
const IndexPage = ({ location }) => {
    const data = useStaticQuery(query)
    const { pageData, posts } = data
    const profile = pageData.summary.split("|")
    const { category } = pageData

    const breadcrums = [category.subtitle || category.name]

    const contents = pageData.content.map((content, index) => {
        let html = null
        if (
            content.Single_Column !== undefined &&
            content.Single_Column !== null
        ) {
            html = (
                <SingleColumn
                    data={content.Single_Column}
                    key={index}
                    className={"content-margin"}
                />
            )
        }
        return html
    })

    const customJsx = (
        <>
            {contents}
            <TeamList url={location.pathname} data={posts.teammembers} />
        </>
    )

    const arrData = {
        location,
        data,
        bgColor:
            "linear-gradient(90deg, #de9adb 25%, #e0a0dd 25%, #e0a0dd 50%, #de9adb 50%, #de9adb 75%, #e0a0dd 75%, #e0a0dd 100%)",
        customElement: customJsx,
        onlyCustom: "partial",
        breadcrums, // allow null
    }

    return <CommonTemplate {...arrData} />
}

export default IndexPage

const query = graphql`
    {
        pageData: strapiPage(slug: { eq: "edn-our-teams" }) {
            title
            menu_title
            description
            summary
            image {
                childImageSharp {
                    gatsbyImageData(placeholder: BLURRED, width: 230)
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                      src
                    }
                }
            }
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
            image {
                childImageSharp {
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
                publicURL
            }
            category {
                name
                subtitle
                category_img {
                    childImageSharp {
                        gatsbyImageData(placeholder: BLURRED)
                    }
                }
            }
            content {
                Single_Column {
                    Text_Alignment
                    content
                    id
                    title
                }
            }
        }
        posts: strapiTeam(slug: { eq: "edn-our-teams" }) {
            strapiId
            name
            slug
            description
            teammembers {
                slug
                name
                title
                description
                short_intro
                image {
                    childImageSharp {
                        gatsbyImageData(
                            placeholder: BLURRED
                            width: 300
                            height: 300
                        )
                        id
                    }
                }
            }
        }
    }
`
